/**
 * @class FacetedFiltersMobile
 * @classdesc The faceted filters mobile component which is included on collection and search pages
 * to allow merchants to filter lists of products dynamically. This class allows filters to be
 * updated without refreshing the page.
 *
 * @extends Core.Component
 */
export default class FacetedFiltersMobile extends Core.Component {
  onMount() {
    this.filterButtons = this.query('filters-buttons-mobile');
    this.activeFilters = this.query('filters-active-mobile');
    this.drawerFilters = this.query('drawer-filters');

    if (this.filterButtons && this.drawerFilters) {
      this.events.register(this.filterButtons.el, 'filter:open', e => {
        const { trigger } = e.detail;
        this.drawerFilters.open(trigger);
      });

      this.events.register(this.drawerFilters.el, 'filter:update', e => {
        const updateEvent = new CustomEvent('filter:update', { detail: e.detail });
        this.el.dispatchEvent(updateEvent);
      });

      this.events.register(this.filterButtons.el, 'filter:update', e => {
        const updateEvent = new CustomEvent('filter:update', { detail: e.detail });
        this.el.dispatchEvent(updateEvent);
      });
    }
  }

  /**
   * Main entrypoint to update all of the components of the mobile filters with any changes
   * based on the newDom.
   *
   * @param {HTMLElement} newDom - The new DOM which should include a new version of the mobile
   * filters html.
   */
  updateFilters(newDom) {
    const newFilterDom = newDom.querySelector('[data-faceted-filters-mobile]');

    if (this.filterButtons) {
      this.filterButtons.updateFilters(newFilterDom);
      this.activeFilters.updateFilters(newFilterDom);
      this.drawerFilters.updateFilters(newFilterDom);
    }
  }
}
